const EXACT_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DOMAIN_ALLOWLIST_RE = /^@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i;

export function normalizeEmailAllowlistEntry(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

export function normalizeSenderAllowlist(value) {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value
        .filter((entry) => typeof entry === 'string')
        .map(normalizeEmailAllowlistEntry)
        .filter((entry) => {
            if (!entry || seen.has(entry)) return false;
            seen.add(entry);
            return true;
        });
}

export function isValidEmailAllowlistEntry(value) {
    const normalized = normalizeEmailAllowlistEntry(value);
    return EXACT_EMAIL_RE.test(normalized) || DOMAIN_ALLOWLIST_RE.test(normalized);
}

export function senderAllowlistIncludes(list, value) {
    const normalized = normalizeEmailAllowlistEntry(value);
    return normalized ? normalizeSenderAllowlist(list).includes(normalized) : false;
}

export function senderMatchesAllowlist(list, senderAddress) {
    const normalizedSender = normalizeEmailAllowlistEntry(senderAddress);
    if (!normalizedSender) return false;
    return normalizeSenderAllowlist(list).some((entry) => (
        entry === normalizedSender
        || (entry.startsWith('@') && normalizedSender.endsWith(entry) && normalizedSender !== entry)
    ));
}
